import BossModel from "@/models/BossModel";
import Proposal from '@/models/Proposal/Proposal';
import User from '@/models/User/User';

export default class Favorite extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/favorite';

    /**
     *
     * @type {string}
     */
    static entity = 'favorites';

    static fields() {
		return {
			id: this.attr(null),
			title: this.attr(null),
			proposal_id: this.number(null).nullable(),
			user_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            proposal: this.belongsTo(Proposal, 'proposal_id'),
            user: this.belongsTo(User, 'user_id'),
		}
	}

    /**
     *
     * @param filters
     * @returns {*}
     */
    static search(filters = {}) {
        return this.api().filtered(filters).get().then(items => {
            let models = [];
            items.forEach(item => {
                models.push(new this(item));
            });
            return models;
        });
    }

    /**
     *
     * @returns {boolean|*}
     */
    User(){
        return this.getRelated('user');
    }

    /**
     *
     * @returns {boolean|*}
     */
    Proposal() {
        return this.getRelated('proposal');
    }
}
